import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from './utils/baseQuery'
import {
    ANSWER_CATEGORY_TAG,
    ASSIGNMENT_TAG,
    CATALOG_ITEM_TAG,
    COMPONENT_TAG,
    FEEDBACK_MODIFICATION_TAG,
    GROUP_TAG,
    PATTERN_TAG,
    PROBLEM_SET_TAG,
    QUESTION_TAG,
    CATEGORY_TAG,
    SENSE_BOOSTER_TAG,
    SHARE_SUGGESTION_TAG,
    VERSION_TAG,
    LTI_GRADES_TAG,
    ESCALATED_ANSWER_TAG,
    APPROVE_ANALYTICS_TAG,
    SUBMISSION_TAG,
    COURSE_TAG,
} from './utils/tags'

const baseApi = createApi({
    reducerPath: 'api',
    tagTypes: [
        PROBLEM_SET_TAG,
        ASSIGNMENT_TAG,
        COMPONENT_TAG,
        GROUP_TAG,
        QUESTION_TAG,
        CATEGORY_TAG,
        CATALOG_ITEM_TAG,
        PATTERN_TAG,
        SENSE_BOOSTER_TAG,
        VERSION_TAG,
        SHARE_SUGGESTION_TAG,
        ANSWER_CATEGORY_TAG,
        LTI_GRADES_TAG,
        ESCALATED_ANSWER_TAG,
        APPROVE_ANALYTICS_TAG,
        SUBMISSION_TAG,
        FEEDBACK_MODIFICATION_TAG,
        COURSE_TAG,
    ],
    baseQuery,
    endpoints: () => ({}),
})

export default baseApi
